import { Icon } from "@chakra-ui/react";

const CurrencyIcon = (props: any) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M12.2308 11.2752C10.8817 10.8725 10.4556 10.4698 10.4556 9.8255C10.4556 9.10067 11.0592 8.61745 12.0178 8.61745C13.0828 8.61745 13.4734 9.18121 13.5089 10.0268H14.787C14.7515 8.85906 14.1479 7.81208 12.9053 7.44966V6H11.1657V7.44966C9.99408 7.73154 9.10651 8.53691 9.10651 9.86577C9.10651 11.396 10.2071 12.1611 11.8757 12.604C13.3314 13.0067 13.6509 13.6107 13.6509 14.2148C13.6509 14.6577 13.3314 15.4228 12.0533 15.4228C10.8462 15.4228 10.3491 14.7785 10.2781 14.0134H9C9.07101 15.4631 10.0296 16.2685 11.1657 16.5503V18H12.9053V16.5906C14.0769 16.349 14.9645 15.5839 15 14.2148C14.9645 12.3221 13.5444 11.6376 12.2308 11.2752Z"
      fill="currentColor"
    />
  </Icon>
);

export default CurrencyIcon;
